package com.shadowings.gero.presentation.screen

import com.shadowings.gero.presentation.util.DevicePreviews
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.Image
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.wrapContentWidth
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.ColorFilter
import androidx.compose.ui.hapticfeedback.HapticFeedbackType
import androidx.compose.ui.platform.LocalHapticFeedback
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import com.shadowings.gero.presentation.component.MdCWord
import com.shadowings.gero.presentation.model.Word
import com.shadowings.gero.presentation.ui.LocalIsDarkMode
import com.shadowings.gero.presentation.util.DeviceClass
import com.shadowings.gero.presentation.util.rememberDeviceInfo
import gero.composeapp.generated.resources.favourite_on
import gero.composeapp.generated.resources.favorite_badge_desc
import com.shadowings.gero.presentation.ui.AppTheme
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.label_reading
import gero.composeapp.generated.resources.word_not_seen_hint
import gero.composeapp.generated.resources.word_unknown_title
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource

@Composable
fun WordItemCard(
    word: Word,
    seen: Boolean,
    languageCode: String,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    isFavorite: Boolean = false
) {
    val localizedMeaning = word.getMeaning(languageCode)
    val deviceInfo = rememberDeviceInfo()
    val glyphSize = if (deviceInfo.deviceClass == DeviceClass.WEB_FULL) 52.dp else 48.dp
    val containerColor = if (seen) {
        MaterialTheme.colorScheme.surfaceContainer
    } else {
        MaterialTheme.colorScheme.surfaceVariant.copy(alpha = 0.5f)
    }

    val borderColor = if (seen) {
        MaterialTheme.colorScheme.outlineVariant.copy(alpha = 0.5f)
    } else {
        MaterialTheme.colorScheme.outlineVariant.copy(alpha = 0.2f)
    }

    val hapticFeedback = LocalHapticFeedback.current
    Card(
        modifier = modifier
            .fillMaxWidth()
            .clickable {
                hapticFeedback.performHapticFeedback(HapticFeedbackType.LongPress)
                onClick()
            },
        shape = RoundedCornerShape(16.dp),
        colors = CardDefaults.cardColors(containerColor = containerColor),
        border = BorderStroke(1.5.dp, borderColor)
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(16.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.SpaceBetween
        ) {
            Column(modifier = Modifier.weight(1f).padding(end = 16.dp)) {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Text(
                        text = if (seen) localizedMeaning else stringResource(Res.string.word_unknown_title),
                        style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold),
                        color = if (seen) MaterialTheme.colorScheme.onPrimaryContainer else MaterialTheme.colorScheme.onSurface.copy(alpha = 0.6f)
                    )
                    if (isFavorite) {
                        Spacer(modifier = Modifier.width(6.dp))
                        Image(
                            painter = painterResource(Res.drawable.favourite_on),
                            contentDescription = stringResource(Res.string.favorite_badge_desc),
                            modifier = Modifier.size(16.dp),
                            colorFilter = if (LocalIsDarkMode.current) {
                                ColorFilter.tint(Color.White)
                            } else {
                                null
                            }
                        )
                    }
                }
                Spacer(modifier = Modifier.height(4.dp))
                if (seen) {
                    Text(
                        text = "${stringResource(Res.string.label_reading)} '${word.reading}'",
                        style = MaterialTheme.typography.bodySmall,
                        color = MaterialTheme.colorScheme.onPrimaryContainer.copy(alpha = 0.8f)
                    )
                } else {
                    Text(
                        text = stringResource(Res.string.word_not_seen_hint),
                        style = MaterialTheme.typography.bodySmall,
                        color = MaterialTheme.colorScheme.onSurface.copy(alpha = 0.4f)
                    )
                }
            }

            // Box di anteprima geroglifici della parola
            Box(
                modifier = Modifier
                    .wrapContentWidth()
                    .alpha(if (seen) 1f else 0.25f)
            ) {
                MdCWord(
                    word = word.gardiner,
                    rtl = false,
                    cart = false,
                    size = glyphSize
                )
            }
        }
    }
}

@DevicePreviews
@Preview
@Preview(name = "Dark", uiMode = 0x20, showBackground = true)
@Composable
private fun WordItemCardPreview() {
    AppTheme {
        Surface {
            WordItemCard(
                word = Word(
                    id = "scrittore",
                    meaning = "scrittore",
                    reading = "sS",
                    gardiner = "Y3:N35:A1h2",
                    note = "Un termine comune",
                    alt1 = null,
                    alt2 = null,
                    articolo = "lo",
                    genitivo = "dello",
                    showInCompendio = true,
                    articoloEn = "the",
                    genitivoEn = "of the"
                ),
                seen = true,
                languageCode = "it",
                onClick = {}
            )
        }
    }
}
